(function () {

    'use strict';

    angular.module('app').config(dashboardUrlConfig);

    dashboardUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function dashboardUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.when('/bba-profile-manager/:id', {
            templateUrl: '/templates/pages/bba-profile-manager/bba-profile-details.html',
            controller: 'BBAProfileDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'profileManager',
                htmlTitle: 'BBA Profile Manager',
                pageTitle: 'BBA Profile Manager',
                name: 'profileManagerDetails'
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();



// WEBPACK FOOTER //
// ./js/urls/bba-profile-manager.js